import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";
import AgedAccountsSummary from "../AgedAccountsSummary.js";

/**
 * Section used to render the aged accounts payables chart associated to a period report.
 *
 * @param {AgedAccountsSummary} agedAccountsSummary - The summary model containing the summary
 * groups and total.
 */
export default class AgedAccountsPayablesSection extends AbstractPeriodReportSection {
	constructor({ agedAccountsSummary } = {}) {
		super(...arguments);

		this._summary = agedAccountsSummary;
	}

	getTitle() {
		return _("Aged Accounts Payables");
	}

	getSummary() {
		return this._summary;
	}

	accept(visitor) {
		return visitor.visitAgedAccountsPayablesSection(this);
	}

	isEnabled() {
		return super.isEnabled() && this.hasAgedAccountsSummary();
	}

	hasAgedAccountsSummary() {
		return this._summary && !this._summary.isEmpty();
	}

	static getType() {
		return "AgedAccountsPayablesSection";
	}

	static getId() {
		return "aged-accounts-payables";
	}

	static isAgedAccountsSection() {
		return true;
	}

	static transformMaterializationData(data, context) {
		data.agedAccountsSummary = AgedAccountsSummary.materialize(
			data.agedAccountsSummary,
			context,
		);
	}
}
